import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Plan } from '@/hooks/api/models';

/**
 * 2311. 支払リトライ有効性チェック
 * [GET] /workspace_payment_failures/:token
 */
type Props = {
  token: string;
};

const workspacePaymentFailure = ({ token }: Props): Promise<{ workspace_identifier: string }> => {
  return axios.get(`/api/workspace_payment_failures/${token}`, {});
};

export const useWorkspacePaymentFailure = (props: Props) => {
  return useQuery({
    queryKey: ['workspace_payment_failure'],
    queryFn: () => workspacePaymentFailure(props),
  });
};
